import { hasSupabaseConfig, supabase } from '../../../shared/api/supabaseClient.js';
import { loadNikkeCatalog } from '../../nikke-catalog/api/nikkeCatalogApi.js';
import { loadMemberPersonalNikkeRows } from '../../personal-nikke/api/personalNikkeApi.js';
import { buildPersonalNikkeLookup } from '../../personal-nikke/domain/personalNikke.js';

// The worker answers 404 with these when the member has no linked account or has never synced. That
// is an empty state, not a failure.
const NOT_SYNCED_CODES = new Set(['member_personal_nikke_not_synced', 'member_personal_nikke_unlinked']);

function requireClient() {
  if (!hasSupabaseConfig || !supabase) throw new Error('서비스 연결 설정을 확인할 수 없습니다.');
  return supabase;
}

export async function loadUnionMemberDetail(memberOpenid) {
  const client = requireClient();
  const openid = String(memberOpenid || '').trim();
  const [detailResult, catalogResult, personalResult] = await Promise.all([
    client.rpc('get_union_member_detail', { p_member_openid: openid }),
    loadNikkeCatalog(),
    loadMemberPersonalNikkeRows(openid).then((value) => ({ value }), (error) => ({ error })),
  ]);
  if (detailResult.error) throw new Error(`멤버 상세정보를 불러오지 못했습니다: ${detailResult.error.message}`);
  const detail = detailResult.data || {};
  // Personal NIKKE lives in Cloudflare D1. The profile and characters this RPC still returns come from
  // the Postgres copy that stopped updating on 2026-08-17, so every member screen showed a month-old
  // roster or nothing at all. Only the practice records and the permission check are taken from it.
  const personal = personalResult.value || null;
  const personalFailure = personalResult.error && !NOT_SYNCED_CODES.has(personalResult.error.code)
    ? personalResult.error
    : null;
  const lookup = buildPersonalNikkeLookup(personal?.characters || [], catalogResult.lookup);
  return {
    ...detail,
    profile: personal?.profile || null,
    characters: lookup.items,
    // The grid below shows overloaded NIKKEs only, so the count of every synced row travels with it
    // to tell "has not synced" apart from "synced, nothing overloaded".
    syncedCharacterCount: lookup.all.length,
    lookup,
    catalog: catalogResult.lookup,
    personalError: personalFailure ? (personalFailure.message || '멤버 니케 정보를 불러오지 못했습니다.') : '',
  };
}
